import SimulationPlayer from '@core/components/Unity/components/SimulationPlayer';
import { Modal } from '@virtidev/toolbox';
import styled from 'styled-components';

export const CompleteModal = styled(Modal)`
  .modal-box {
    max-width: 600px;
  }
`;

export const PublicSimPlayer = styled(SimulationPlayer)`
  height: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;
